import {styled} from "@mui/material/styles";
import {Popper} from "@mui/material";

export const RowContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0 6px;
  background-color: transparent;
`;

export const SubRowContainer = styled(RowContainer)`
  justify-content: flex-start;
  gap: 12px;
  background-color: transparent;
`;

export const ShapeModePopper = styled(Popper)`
  width: 450px;
  z-index: 1200;
  background-color: #F57B20;
  color: #FFF;
  border-radius: 8px;
`;
